<div class="info-container" *ngIf="longTermPaymentSchedule && longTermPaymentSchedule.length > 0">
  <div class="label header">{{'bikeshop.rentals.booking.long_term_payment_schedule' | translate}}</div>

  <div class="payment-history-container">
    <div class="row header">
      <div class="col-3 text-left">{{ 'bikeshop.rentals.booking.status' | translate }}</div>
      <div class="col-3 text-left">{{ 'bikeshop.rentals.booking.schedule_date' | translate }}</div>
      <div class="col-2 text-left">{{ 'bikeshop.rentals.booking.date_paid' | translate }}</div>
      <div class="col-3 text-left">{{ 'bikeshop.rentals.booking.payment_amount' | translate }}</div>
      <div class="col-1 text-right">Action</div>
    </div>

    <div *ngFor="let payment of longTermPaymentSchedule">
      <!--Start Display Row-->
      <div class="row" *ngIf="!payment.edit">        
        <div class="col-3 text-left">
          <div class="payment-status-label" [ngClass]="{
            'scheduled': payment.statusID === 0,
            'paid': payment.statusID === 1,
            'payment-failed': payment.statusID === 2,
            'cancelled': payment.statusID === 100
            }">{{getStatus(payment.statusID) | translate}}
          </div>
          <div *ngIf="payment.statusID === 2 && payment.paymentFailures && payment.paymentFailures.length > 0">
              <span class="fa fa-exclamation-triangle" pTooltip="{{payment.paymentFailures[0].error}}"></span>
              <span class="fa fa-refresh" [ngClass]="{'rotate': retryingPayment}" pTooltip="{{ 'bikeshop.rentals.booking.retry_payment' | translate }}" (click)="retryProcessRentalsRecuringPayment(payment.id)"></span>
          </div>
        </div>
        <div class="col-3 text-left">{{(payment.scheduleDate+ 'Z') | date : countryData.AngularDateFormat}}</div>
        <div class="col-2 text-left">
          <div *ngIf="payment.paymentDate">{{(payment.paymentDate+ 'Z') | date : countryData.AngularDateFormat}}</div>
        </div>
        <div class="col-3 text-left">
          {{partner.CurrencySymbol}}{{payment.total.toFixed(2)}} 
        </div>  
        <div class="col-1 actions text-right">
          <span 
          *ngIf="payment.statusID !== 1 && payment.statusID !== 100" 
          class="fa fa-fw hubtiger-edit" 
          (click)="editScheduleItem(payment)" 
          title="Edit schedule item."></span>
        </div>     
      </div>
      <!--End Display Row-->
      <!--Start Edit Row-->
      <div class="row" *ngIf="payment.edit">
       <div class="col-3 text-left">
        <!-- start status dropdown -->
        <p-dropdown 
        [options]="longTermPaymentScheduleStatuesesForDropdown" 
        [(ngModel)]="selectedStatusID"
        placeholder="Status"
        (onChange)="onStatusChange($event, payment)"
        optionLabel="label"
        ></p-dropdown>
        <!-- end status dropdown -->
       </div>

       <div class="col-3 text-left">
        <!-- start schedule date picker -->
        <div class="input-icon-right">
          <p-calendar 
          [dateFormat]="countryData.DatePickerFormat"
          [minDate]="today"
          [hideOnDateTimeSelect]="true" 
          [(ngModel)]="payment.scheduleDate"
          [readonlyInput]="true"
          ></p-calendar>
          <i class="fa fa-calendar"></i>
        </div>
        <!-- end schedule date picker -->
       </div>

       <div class="col-2 text-left">
        <!-- start date paid (view only) -->
        <div *ngIf="payment.paymentDate">{{(payment.paymentDate+ 'Z') | date : countryData.AngularDateFormat}}</div>
        <!-- end date paid (view only) -->
       </div>

       <div class="col-3 text-left">
        <!-- start amount -->
        <input 
        type="number" 
        pInputText [(ngModel)]="payment.total"               
        placeholder="Price"              
        />
        <!-- end amount -->        
       </div>

       <div class="col-1 text-right actions">
        <!-- start save button -->
        <span style="margin-right:16px;"        
          class="fa fa-check" 
          (click)="setScheduleItem(payment)" 
          title="Save"></span>
        <!-- end save button -->

        <!-- start cancel button -->
        <span          
          class="fa fa-times" 
          (click)="cancelScheduleItem(payment)" 
          title="Cancel"></span>
        <!-- end cancel button -->
       </div>
        
      </div> 
      <!--End Edit Row-->     
    </div>

    <div class="row margin-top-16">
        <div class="col-md-2"></div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
            <button pButton type="button" class="p-button-raised full-width" (click)="addScheduleItem()"
                    label="{{'bikeshop.rentals.booking.long_term_payment.added_button'| translate}}"></button>
        </div>
    </div>

  </div>

</div>